document.addEventListener('DOMContentLoaded', function () {
    var DEBUG = true;
    function log() {
        if (!DEBUG) return;
        var args = Array.prototype.slice.call(arguments);
        args.unshift('[mobile-menu]');
        console.log.apply(console, args);
    }

    log('DOM ready. URL:', window.location.href);
    log('.open-menu elements found at DOM ready:', document.querySelectorAll('.open-menu').length);
    log('.mobile-menu elements found at DOM ready:', document.querySelectorAll('.mobile-menu').length);

    function init() {
        var menu = document.querySelector('.mobile-menu');
        if (!menu) {
            log('init(): .mobile-menu NOT yet in DOM, will retry via observer.');
            return false;
        }
        log('init(): .mobile-menu found ->', menu);
        log('init(): parent of .mobile-menu ->', menu.parentElement && menu.parentElement.tagName);

        // Move menu to top of body so the fixed overlay always sits above page content.
        if (menu.parentElement !== document.body || menu !== document.body.firstElementChild) {
            document.body.insertBefore(menu, document.body.firstChild);
            log('init(): moved .mobile-menu to top of <body>.');
        }

        var menuUl = menu.querySelector('ul.menu');
        log('init(): ul.menu found?', !!menuUl, menuUl);
        log('init(): close button found?', !!menu.querySelector('.mobile-menu-close'));

        function setMenuState(open) {
            log('setMenuState ->', open);
            menu.classList.toggle('menu-opened', open);
            document.body.classList.toggle('menu-opened', open);
            document.querySelectorAll('.open-menu').forEach(function (trigger) {
                trigger.classList.toggle('is-active', open);
                trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
            });
            if (menuUl) {
                var cs = window.getComputedStyle(menuUl);
                log('ul.menu computed -> display:', cs.display, '| max-height:', cs.maxHeight, '| opacity:', cs.opacity, '| pointer-events:', cs.pointerEvents);
            }
            log('menu classes after toggle:', menu.className);
            log('body classes after toggle:', document.body.className);
        }

        // Delegate clicks for any current or future .open-menu element
        document.addEventListener('click', function (e) {
            var trigger = e.target.closest && e.target.closest('.open-menu');
            if (trigger) {
                log('click on .open-menu trigger:', trigger);
                e.preventDefault();
                var isOpen = menu.classList.contains('menu-opened');
                setMenuState(!isOpen);
                return;
            }
            var closeBtn = e.target.closest && e.target.closest('.mobile-menu-close');
            if (closeBtn) {
                log('click on .mobile-menu-close');
                e.preventDefault();
                setMenuState(false);
                return;
            }

            // Close menu when a menu item link is clicked (but not the submenu arrow)
            var menuLink = e.target.closest && e.target.closest('.mobile-menu ul.menu a');
            if (menuLink && !e.target.closest('.submenu-arrow')) {
                log('click on menu item link, closing menu:', menuLink.href);

                // If link points to an anchor on the current page, scroll instead of reloading.
                var href = menuLink.getAttribute('href') || '';
                var hashIndex = href.indexOf('#');
                if (hashIndex !== -1 && href.length > hashIndex + 1) {
                    var linkUrl;
                    try {
                        linkUrl = new URL(menuLink.href, window.location.href);
                    } catch (err) {
                        linkUrl = null;
                    }
                    if (linkUrl &&
                        linkUrl.origin === window.location.origin &&
                        linkUrl.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '') &&
                        linkUrl.hash) {
                        var targetId = decodeURIComponent(linkUrl.hash.slice(1));
                        var targetEl = document.getElementById(targetId) ||
                            document.querySelector('a[name="' + targetId + '"]');
                        if (targetEl) {
                            e.preventDefault();
                            setMenuState(false);
                            // Update the URL hash without jumping, then smooth-scroll.
                            if (history.pushState) {
                                history.pushState(null, '', linkUrl.hash);
                            }
                            targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            log('same-page anchor scroll ->', targetId);
                            return;
                        }
                    }
                }

                setMenuState(false);
            }
        });

        // Helpful: confirm trigger exists on page
        var triggers = document.querySelectorAll('.open-menu');
        log('init(): .open-menu triggers on page:', triggers.length, triggers);
        if (triggers.length === 0) {
            console.warn('[mobile-menu] No element with class "open-menu" was found. Add class="open-menu" to your hamburger element.');
        }

        // Close menu on Escape
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && menu.classList.contains('menu-opened')) {
                setMenuState(false);
            }
        });

        // Submenu handling
        function setupSubmenus(parentItems) {
            parentItems.forEach(function (item) {
                var submenu = item.querySelector('ul.sub-menu');
                if (!submenu) return;

                var link = item.querySelector('a');
                if (!link) return;

                if (!link.querySelector('.submenu-arrow')) {
                    link.insertAdjacentHTML(
                        'beforeend',
                        ' <span class="submenu-arrow" aria-hidden="true"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg></span>'
                    );
                }

                var arrow = link.querySelector('.submenu-arrow');
                arrow.style.display = 'inline-flex';
                arrow.style.alignItems = 'center';
                arrow.style.justifyContent = 'center';
                arrow.style.verticalAlign = 'middle';
                arrow.style.marginLeft = '0.5rem';
                arrow.style.width = '2rem';
                arrow.style.height = '2rem';
                arrow.style.transformOrigin = '50% 50%';
                arrow.style.transform = 'rotate(0deg)';
                arrow.style.color = '#ffffff';
                arrow.style.transition = 'transform 0.3s ease';
                arrow.style.cursor = 'pointer';

                arrow.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var isOpen = !item.classList.contains('open');
                    item.classList.toggle('open', isOpen);
                    arrow.style.transform = isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
                    submenu.style.display = 'block';
                    setTimeout(function () {
                        submenu.style.maxHeight = isOpen ? '500px' : '0';
                        submenu.style.opacity = isOpen ? '1' : '0';
                        var submenuItems = submenu.querySelectorAll('li.menu-item');
                        submenuItems.forEach(function (subItem) {
                            subItem.style.transitionDelay = '0s';
                            subItem.style.transform = isOpen
                                ? 'scale(1) translateY(0)'
                                : 'scale(1) translateY(0)';
                            subItem.style.opacity = isOpen ? '1' : '0';
                        });
                        var nestedItems = submenu.querySelectorAll('li.menu-item-has-children');
                        nestedItems.forEach(function (nestedItem) {
                            var nestedSubmenu = nestedItem.querySelector('ul.sub-menu');
                            if (nestedSubmenu) {
                                nestedSubmenu.style.display = 'none';
                                nestedSubmenu.style.maxHeight = '0';
                                nestedSubmenu.style.opacity = '0';
                                nestedItem.classList.remove('open');
                                var nestedArrow = nestedItem.querySelector('.submenu-arrow');
                                if (nestedArrow) nestedArrow.style.transform = 'rotate(0deg)';
                            }
                        });
                    }, 0);
                });

                if (link.href) {
                    link.addEventListener('click', function (e) {
                        if (e.target === arrow || arrow.contains(e.target)) {
                            e.preventDefault();
                        } else {
                            window.location.href = this.href;
                        }
                    });

                    var touchStartTime = 0;
                    link.addEventListener('touchstart', function () {
                        touchStartTime = new Date().getTime();
                    }, { passive: true });

                    link.addEventListener('touchend', function (e) {
                        var touchDuration = new Date().getTime() - touchStartTime;
                        if (touchDuration > 500 && e.target !== arrow && !arrow.contains(e.target)) {
                            e.preventDefault();
                            window.location.href = this.href;
                        }
                    });
                }

                setupSubmenus(submenu.querySelectorAll(':scope > li.menu-item-has-children'));
            });
        }

        setupSubmenus(menu.querySelectorAll('.menu > li.menu-item-has-children'));
        log('init(): completed successfully.');
        return true;
    }

    if (!init()) {
        log('Starting MutationObserver fallback (waiting for .mobile-menu to appear).');
        // Fallback: wait for the menu to be inserted (e.g. late footer rendering).
        var observer = new MutationObserver(function () {
            if (init()) {
                log('MutationObserver: init succeeded, disconnecting.');
                observer.disconnect();
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }
});